import { useEffect, useRef, useState } from "react";

export const useOverflow = <T extends HTMLElement>() => {
  const contentRef = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkRef = () => {
    const currentRef = contentRef.current;
    if (!currentRef) return;

    setIsOverflowing(currentRef.scrollWidth > currentRef.clientWidth);
  };

  useEffect(() => {
    const currentRef = contentRef.current;
    if (!currentRef) return;

    const resizeObserver = new ResizeObserver(checkRef);
    if (currentRef) {
      resizeObserver.observe(currentRef);
    }

    // observe parent element to catch column / parent resizing
    let parentObserver: ResizeObserver | null = null;
    if (currentRef.parentElement) {
      parentObserver = new ResizeObserver(checkRef);
      parentObserver.observe(currentRef.parentElement);
    }

    checkRef();

    return () => {
      resizeObserver.disconnect();
      if (parentObserver) {
        parentObserver.disconnect();
      }
    };
  }, [contentRef]);

  return { contentRef, isOverflowing };
};
